/**
 * Retourne vrai s'il faut afficher la liste des informations de l'estimation.
 */
export default function bookingEstimateHasList({ bookingEstimate }) {
  return (
    Boolean(bookingEstimate) &&
    bookingEstimate.periodsAmountWithoutDiscounts > 0
  );
}
